var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-header',[_c('div',{staticClass:"header-col header-brand"},[_c('img',{staticStyle:{"max-height":"5vh"},attrs:{"src":_vm.tenantImg}})]),_c('div',{staticClass:"header-col header-nav",staticStyle:{"margin-left":"5vh"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }